import React from 'react'
import LocalConvenienceStore from '@mui/icons-material/LocalConvenienceStore';
import loadable from '@loadable/component'


 const MasterChainConf = {
    list: loadable(() => import("./MasterChainList")),
    icon: <LocalConvenienceStore />,
    edit: loadable(() => import("./MasterChainEdit")),
    options: {
        label: 'Master Chain',
        items: true
    }
};

export default MasterChainConf